/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".iconized-button[_ngcontent-%COMP%]{margin:5px!important}.iconized-button[_ngcontent-%COMP%]   .mat-button[_ngcontent-%COMP%]{height:30px!important;outline:#a9a9a9 solid 1px}.iconized-button[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:not(:first-child){margin-left:10px}i[_ngcontent-%COMP%]{vertical-align:middle!important}"];
export { styles as styles };
